import { Header } from './components/header';
import { Layout } from './components/layout';
import './style/global.css'

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Layout></Layout>
  
    </div>
  );
}

export default App;
